import React from 'react';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { CloseButton, DeleteButton } from '../_Components';
let openConfirmFn;

class Confirm extends React.Component {
  state = {
    open: false,
    message: '',
    title: 'Закрыть?',
    confirmLabel: 'Закрыть'
  };

  componentDidMount() {
    openConfirmFn = this.openConfirm;
  }

  openConfirm = ({title, message, value , ...props}, onConfirm, onClose) => {
    this.setState({ open: true, title, message, onConfirm, onClose, value, ...props });
  };

  onClose = () => {
    this.setState({ open: false });
  }

  onConfirm = () =>{
    this.setState({ open: false });
    this.state.onConfirm(this.state.value);
  }

  render() {
    const { open, title, message, confirmLabel  } = this.state;
    return (
      <Dialog
        open={open}
        TransitionComponent={Slide}
        keepMounted
        onClose={this.handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{color: '#0a529f'}}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <DeleteButton label={confirmLabel} handleDeleteClick={() => this.onConfirm()} />
          <CloseButton label="Отмена" handleCloseClick={() => this.onClose()} />
        </DialogActions>
      </Dialog>
    );
  }
}

export default Confirm;

export function openConfirm(obj, onConfirm, onClose) {
  return openConfirmFn(obj, onConfirm, onClose);
}